import { FC, PropsWithChildren } from "react";

const OnboardingBody: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <div className="onboarding__body">{children}</div>;
};

export default OnboardingBody;
